{
  "info": "Informação",
  "negative": "Erro",
  "notice": "Aviso",
  "positive": "Sucesso"
}
